(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marbl-boxes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var cta = event.target.closest('.marbl-cut-dropdown__cta');
    if (!cta || cta.disabled) return;

    var dropdown = cta.closest('[data-marbl-dropdown]');
    if (!dropdown || !dropdown.closest('#boxes')) return;

    // Orders closed (T13): join the waitlist with this box noted; never touch the cart.
    if (dropdown.dataset.ordersClosed === 'true') {
      if (typeof window.marblOpenWaitlist === 'function') {
        window.marblOpenWaitlist({ interest: dropdown.dataset.tier });
      } else {
        console.warn('Marbl: waitlist form not on this page');
      }
      return;
    }

    var capacity = parseInt(dropdown.dataset.capacity, 10) || 0;
    var capacityMode = dropdown.dataset.capacityMode || 'exact';
    var variantId = dropdown.dataset.variantId;
    var weeklyId = dropdown.dataset.planWeeklyId;
    var fortnightlyId = dropdown.dataset.planFortnightlyId;
    var monthlyId = dropdown.dataset.planMonthlyId;

    if (!variantId) {
      alert('This box is not available right now — please try another, or contact us at counter@marbl-food.com.');
      return;
    }

    var rows = dropdown.querySelectorAll('.marbl-cut-dropdown__row');
    var properties = {};
    var total = 0;
    var weightGrams = 0;

    rows.forEach(function (row) {
      var stepper = row.querySelector('[data-marbl-stepper]');
      var value = stepper ? parseInt(stepper.dataset.value, 10) || 0 : 0;
      var unitWeightGrams = parseInt(row.dataset.weightGrams, 10) || 0;
      var name = row.dataset.cutName;

      if (value > 0) {
        properties[name] = '×' + value + ' (' + ((value * unitWeightGrams) / 1000).toFixed(1) + ' kg)';
        total += value;
        weightGrams += value * unitWeightGrams;
      }
    });

    var meetsCapacity = capacityMode === 'minimum' ? total >= capacity : total === capacity;
    if (!meetsCapacity) {
      var message = capacityMode === 'minimum'
        ? 'Choose at least ' + capacity + ' units before checking out.'
        : 'Choose exactly ' + capacity + ' units before checking out.';
      alert(message);
      return;
    }

    properties['Total weight'] = '≈ ' + (weightGrams / 1000).toFixed(1) + ' kg';

    var frequency = dropdown.dataset.frequency || 'once-off';
    var quantity = capacityMode === 'minimum' ? total : 1;
    var item = { id: parseInt(variantId, 10), quantity: quantity, properties: properties };

    if (frequency === 'weekly' && weeklyId) {
      item.selling_plan = parseInt(weeklyId, 10);
    } else if (frequency === 'fortnightly' && fortnightlyId) {
      item.selling_plan = parseInt(fortnightlyId, 10);
    } else if (frequency === 'monthly' && monthlyId) {
      item.selling_plan = parseInt(monthlyId, 10);
    } else if (frequency !== 'once-off') {
      alert('That frequency is not available for this box right now — please choose another, or contact us.');
      return;
    }

    // Add-ons: separate line items, never a selling plan (one-off only, even on a recurring box).
    var items = [item];
    var addonRows = dropdown.querySelectorAll('.marbl-cut-dropdown__addon-row');
    addonRows.forEach(function (row) {
      var addonStepper = row.querySelector('[data-marbl-stepper]');
      var addonQty = addonStepper ? parseInt(addonStepper.dataset.value, 10) || 0 : 0;
      var addonVariantId = row.dataset.addonVariantId;
      if (addonQty > 0 && addonVariantId) {
        items.push({ id: parseInt(addonVariantId, 10), quantity: addonQty });
      }
    });

    cta.dataset.marblLabel = cta.dataset.marblLabel || cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding…';

    function parseJsonSafely(response) {
      return response.json().catch(function () { return null; });
    }

    fetch(window.routes.cart_clear_url || '/cart/clear.js', { method: 'POST' })
      .then(function (clearResponse) {
        return parseJsonSafely(clearResponse).then(function (clearData) {
          var cleared = clearData && Array.isArray(clearData.items) && clearData.items.length === 0;
          if (!clearResponse.ok || !cleared) {
            throw new Error('Could not clear your cart — please try again.');
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
          });
        });
      })
      .then(function (response) {
        return parseJsonSafely(response).then(function (data) {
          var added = data && data.items && data.items.length > 0;
          if (!response.ok || !added) {
            throw new Error((data && data.description) || 'Could not add this box to your cart — please try again.');
          }
          window.location.href = '/checkout';
        });
      })
      .catch(function (error) {
        alert(error.message);
        cta.disabled = false;
        cta.textContent = 'Continue to checkout';
      });
  });

  // 2026-09-24 (v15): Back from /checkout restores this page from the back/forward cache with the
  // CTA still disabled on "Adding…" (the v12 bug). Put the label back and let the dropdown
  // recompute whether the CTA should be enabled for the cuts still chosen.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('#boxes .marbl-cut-dropdown__cta').forEach(function (cta) {
      if (cta.dataset.marblLabel) cta.textContent = cta.dataset.marblLabel;
      var dropdown = cta.closest('[data-marbl-dropdown]');
      if (dropdown) dropdown.dispatchEvent(new CustomEvent('marbl:stepper-change', { bubbles: true }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marbl-change-cuts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var picker = event.target.closest('[data-marbl-change-cuts-picker] .marbl-segmented__option');
    if (!picker) return;

    picker.parentElement.querySelectorAll('.marbl-segmented__option').forEach(function (btn) {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });
    picker.classList.add('is-selected');
    picker.setAttribute('aria-pressed', 'true');

    document.querySelectorAll('[data-marbl-change-cuts-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.marblChangeCutsPanel !== picker.dataset.panel;
    });
  });

  document.addEventListener('click', function (event) {
    var cta = event.target.closest('.marbl-cut-dropdown__cta');
    if (!cta || cta.disabled) return;

    var form = cta.closest('form');
    if (!form || !form.matches('#marbl-change-cuts-form')) return;

    var dropdown = cta.closest('[data-marbl-dropdown]');
    if (!dropdown) return;

    var rows = dropdown.querySelectorAll('.marbl-cut-dropdown__row');
    var lines = ['Change your cuts request', '', 'Requested box: ' + dropdown.dataset.tierName];
    var total = 0;
    var weightGrams = 0;

    rows.forEach(function (row) {
      var stepper = row.querySelector('[data-marbl-stepper]');
      var value = stepper ? parseInt(stepper.dataset.value, 10) || 0 : 0;
      var unitWeightGrams = parseInt(row.dataset.weightGrams, 10) || 0;
      if (value > 0) {
        lines.push(row.dataset.cutName + ': ×' + value + ' (' + ((value * unitWeightGrams) / 1000).toFixed(1) + ' kg)');
        total += value;
        weightGrams += value * unitWeightGrams;
      }
    });

    lines.push('Total: ' + total + ' units, ≈' + (weightGrams / 1000).toFixed(1) + ' kg');

    var summary = form.querySelector('[data-marbl-change-cuts-summary]');
    if (summary) summary.value = lines.join('\n');

    // Deferred to the next tick, not set synchronously here: disabling a type="submit" button
    // mid-click can cancel the native form submission in some browsers. This guard only needs
    // to stop a second click (rapid double-click, slow connection) from sending Owen a
    // duplicate email — it doesn't need to block the click that's already in flight.
    window.setTimeout(function () {
      cta.disabled = true;
    }, 0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marbl-delivery-checker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-marbl-delivery-checker]');
    if (!form) return;
    event.preventDefault();

    var wrapper = form.closest('.marbl-delivery-checker__form');
    var input = form.querySelector('input[name="postcode"]');
    var result = wrapper.querySelector('[data-marbl-delivery-result]');
    var waitlist = wrapper.querySelector('[data-marbl-delivery-waitlist]');
    if (!input || !result) return;

    var zones = [];
    try { zones = JSON.parse(form.dataset.zones); } catch (e) { zones = []; }

    var postcode = input.value.trim();

    if (!/^\d{4}$/.test(postcode)) {
      result.hidden = false;
      result.textContent = 'Enter a 4-digit postcode to check.';
      if (waitlist) waitlist.hidden = true;
      return;
    }

    var inZone = zones.indexOf(postcode) !== -1;
    var ordersOpen = form.dataset.ordersOpen === 'true';

    result.hidden = false;
    if (inZone) {
      result.textContent = ordersOpen
        ? 'Good news — we deliver to ' + postcode + '. Order by 11:59pm Monday and your box arrives that weekend.'
        : 'Good news — we deliver to ' + postcode + '.';
    } else {
      result.textContent = "We don't deliver to " + postcode + " yet. Join the waitlist and we'll let you know as we widen, suburb by suburb.";
    }

    if (waitlist) {
      waitlist.hidden = inZone;
      var opener = waitlist.querySelector('[data-marbl-waitlist-open]');
      if (opener) opener.dataset.postcode = inZone ? '' : postcode;
    }

    // Out of zone: open the site's one waitlist form with this postcode prefilled (T12).
    if (!inZone) {
      if (typeof window.marblOpenWaitlist === 'function') {
        window.marblOpenWaitlist({ postcode: postcode, outOfZone: true });
      } else {
        console.warn('Marbl: waitlist form not on this page');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marbl-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-marbl-nav]');
    if (!nav) return;

    var links = nav.querySelectorAll('[data-marbl-nav-link]');
    var targets = [];
    links.forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) targets.push({ link: link, target: target });
    });

    if (!targets.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var match = targets.find(function (item) { return item.target === entry.target; });
        if (!match) return;
        if (entry.isIntersecting) {
          links.forEach(function (link) { link.classList.remove('is-active'); });
          match.link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-64px 0px -70% 0px' });

    targets.forEach(function (item) { observer.observe(item.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
